import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import {
	formatRecommendationClearance,
	formatRecommendationObjective,
	formatRecommendationYesNo,
	isRecommendationTraining,
	recommendationSessionLabel,
} from "src/app/cbta-web/ratings/container-ratings-form/shared-v2/utils/recommendation-summary.utils";
import { ReportSummary, Ts1V3ReportPreviewSummary } from "src/app/models/models";
import { buildSummaryReportTitle } from "src/app/shared/utils/form-type-label";

@Component({
	selector: "app-ts1-report-preview-summary",
	templateUrl: "./ts1-report-preview-summary.component.html",
	styleUrls: ["./ts1-report-preview-summary.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class Ts1ReportPreviewSummaryComponent {
	@Input() reportSummary?: ReportSummary;
	@Input() preview?: Ts1V3ReportPreviewSummary;

	readonly formatRecommendationYesNo = formatRecommendationYesNo;
	readonly formatRecommendationObjective = formatRecommendationObjective;
	readonly formatRecommendationClearance = formatRecommendationClearance;
	readonly isRecommendationTraining = isRecommendationTraining;
	readonly recommendationSessionLabel = recommendationSessionLabel;

	get summaryReportTitle(): string {
		return buildSummaryReportTitle(this.reportSummary?.formType);
	}

	get candidateDetails() {
		return this.preview?.candidateDetails;
	}

	get ratings() {
		return (
			this.preview?.ratings ?? {
				ratingA: this.reportSummary?.sessionDetails?.ratingA,
				ratingB: this.reportSummary?.sessionDetails?.ratingB,
				ratingC: this.reportSummary?.sessionDetails?.ratingC,
				finalRating: this.reportSummary?.sessionDetails?.finalRating,
			}
		);
	}

	get maneuverRows() {
		return this.preview?.maneuverRows ?? [];
	}

	get recommendation() {
		return this.reportSummary?.recommendation;
	}
}
